import React from 'react';
import PageLayout from '../../components/layout/PageLayout';
import CultureHero from './components/CultureHero';
import JobBoard from './components/JobBoard';
import ApplicationPortal from './components/ApplicationPortal';

const CareersHub = () => {
  return (
    <PageLayout
      title="Careers Hub - Join Our Team"
      description="Discover career opportunities at Ons Mettle. Join our team of exceptional professionals and accelerate your career while making meaningful impact on leading organizations."
      keywords={['careers', 'jobs', 'consulting careers', 'professional development', 'team growth']}
    >
      <CultureHero />
      <JobBoard />
      <ApplicationPortal />
    </PageLayout>
  );
};

export default CareersHub;